import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-responsive-modal';
import axios from 'axios'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import 'react-responsive-modal/styles.css';

export class PriceLists extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      priceLists: [],
      name: '',
      modalOpen: false
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  filterChange(evt) {
    this.refs.nameFilter.applyFilter(evt.target.value);
  }

  componentWillMount() {
    this.fetchPriceLists();
  }

  addPriceList = async () => {
    let requestParams = {
      'name': this.state.name,
    }
    axios.post('/pricelists', requestParams)
        .then(data => {
            this.closeModal()
            toast.success('Added Price List!')
            this.fetchPriceLists();
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to add price list')
        })
  }

  fetchPriceLists = async () => {
    axios.get('/pricelists')
      .then(data => {
        this.setState({
          priceLists: data
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to fetch price lists')
      })
  }

  deletePriceList = async (priceListID) => {
      axios.delete('/pricelists/' + priceListID)
        .then(data => {
            this.fetchPriceLists();
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Error: Price List is assigned to user, cannot delete.');
        })
  }

  exportPriceList = async (priceListID, priceListName) => {
    toast.warning('Generating Report...please wait', {autoClose: false})
    let requestParams = {
      'priceListID': priceListID,
      'priceListName': priceListName
    }
    axios.post('/pricelists/export', requestParams)
        .then(data => {
          toast.dismiss()
          toast.success('Report sent via email')
        })
        .catch (err => {
          toast.dismiss()
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to export price list')
        })
  }

  cellButton(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <button type="button" onClick={() => this.deletePriceList(row.priceListID)} className="btn btn-danger btn-sm mar-right">Delete</button>
        <button type="button" onClick={() => this.exportPriceList(row.priceListID, row.priceListName)} className="btn btn-warning btn-sm mar-right">Export</button>
        <Link to={'/pricelists/edit/' + row.priceListID}><button type="button" className="btn btn-info btn-sm">Edit</button></Link>
      </div>
    )
  }

  openModal = () => {
		this.setState({ modalOpen: true });
	};

	closeModal = () => {
		this.setState({ modalOpen: false });
	};

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Price Lists</h1>
            </div>
            <div className="row">
              <div className="col-sm-8 my-auto">
                <button type="button" className="btn btn-success btn-sm mar-bot" onClick={this.openModal} >Add Price List</button>
              </div>
              <div className="col-sm-4 my-auto">
                <div className="input-group mar-bot">
                  <div className="input-group-prepend">
                    <span className="input-group-text"><i className="fa fa-search"></i></span>
                  </div>
                  <input type="text" className="form-control" placeholder="Name..." onChange={this.filterChange.bind(this)}/>
                </div>
              </div>
            </div>
            <BootstrapTable data={this.state.priceLists} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
              <TableHeaderColumn dataField="priceListID" dataSort={true} isKey={true}>ID</TableHeaderColumn>
              <TableHeaderColumn ref='nameFilter' dataField="priceListName" dataSort={true} filter={{ type: 'TextFilter' }}>Name</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.cellButton.bind(this)}>Action</TableHeaderColumn>
            </BootstrapTable>
            <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add Price List</h5>
                    <button type="button" className="close" onClick={this.closeModal}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label>Price List Name:</label>
                      <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange} />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                    <button type="button" onClick={this.addPriceList} className="btn btn-primary" disabled={!this.state.name}>Save changes</button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        );
    }
}
